// @ts-nocheck
// components/FirstAccessModal.tsx
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import api from "../../services/api";
import useStore from "../../store/useStore";
import { parseAuthToken } from "../../utils/jwt";

interface FirstAccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  userEmail: string; // Email do usuário atual
}

export function FirstAccessModal({ isOpen, onClose, userEmail }: FirstAccessModalProps) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser, user } = useStore((state) => state);
  // Função para validar a força da senha
  const validatePassword = (password: string) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (password.length < minLength) {
      return "A senha deve ter pelo menos 8 caracteres";
    }
    if (!hasUpperCase) {
      return "A senha deve ter pelo menos uma letra maiúscula";
    }
    if (!hasLowerCase) {
      return "A senha deve ter pelo menos uma letra minúscula";
    }
    if (!hasNumbers) {
      return "A senha deve ter pelo menos um número";
    }
    if (!hasSpecialChar) {
      return "A senha deve ter pelo menos um caractere especial";
    }
    return "";
  };

  const handleChangePassword = async () => {
    try {
      setError("");

      // Validação das senhas
      if (newPassword !== confirmPassword) {
        setError("As senhas não coincidem");
        return;
      }

      const validationError = validatePassword(newPassword);
      if (validationError) {
        setError(validationError);
        return;
      }

      setLoading(true);
      const body = {
        email: userEmail,
        password: newPassword,
      };
      const r = await api.post("/user/set-password", body);
      const response = await api.post("/login", body);
      const { access_token } = response.data;
      localStorage.setItem("@tlp-authToken", access_token);
      const userData = parseAuthToken();
      if (userData) {
        setUser(userData);
      }
      onClose();
    } catch (error) {
      console.error("Erro ao alterar a senha:", error);
      setError("Erro ao alterar a senha. Tente novamente.", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent
        className="sm:max-w-[425px]"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Alterar Senha</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <p className="text-sm text-gray-200">
            Por motivos de segurança, você precisa alterar sua senha no primeiro acesso.
          </p>
          <div className="space-y-2">
            <Input
              type="password"
              placeholder="Nova senha"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Input
              type="password"
              placeholder="Confirme a nova senha"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          {error && <p className="text-sm text-red-500">{error}</p>}
          <Button className="w-full" onClick={handleChangePassword} disabled={loading}>
            {loading ? "Alterando..." : "Alterar Senha"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
